import React from "react"

type BookingContextValue = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  openModal: () => void
  closeModal: () => void
}

const BookingContext = React.createContext<BookingContextValue | undefined>(
  undefined
)

export const BOOKING_QUERY_PARAM = "datban"

export const BookingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.has(BOOKING_QUERY_PARAM)) {
      setOpen(true)
      params.delete(BOOKING_QUERY_PARAM)
      const newUrl =
        params.toString().length > 0
          ? `${window.location.pathname}?${params.toString()}`
          : window.location.pathname
      window.history.replaceState({}, "", newUrl)
    }
  }, [])

  const openModal = React.useCallback(() => setOpen(true), [])
  const closeModal = React.useCallback(() => setOpen(false), [])

  const value = React.useMemo(
    () => ({ open, setOpen, openModal, closeModal }),
    [open]
  )

  return (
    <BookingContext.Provider value={value}>{children}</BookingContext.Provider>
  )
}

export function useBooking(): BookingContextValue {
  const ctx = React.useContext(BookingContext)
  if (!ctx) {
    throw new Error("useBooking must be used within a BookingProvider")
  }
  return ctx
}
